import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Texteingabe auf Basis von `.sec-input`. Konsumenten sollten ueber `<Label>`
 * (htmlFor) oder `aria-label` eine zugaengliche Beschriftung bereitstellen.
 */
export const Input = forwardRef(function Input({ className, type = 'text', ...rest }, ref) {
    return _jsx("input", { ref: ref, type: type, className: cn('sec-input', className), ...rest });
});
